export default function CAssignmentOperators() {
  return <h2>C Assignment Operators</h2>;
}
